// src/pages/Admin/VotePage/components/VoteStatsGrid.jsx

import React from "react";

import {
  FaClock,
  FaQuestionCircle,
  FaUsers,
  FaVoteYea,
} from "react-icons/fa";

import VoteStatCard from "../ui/VoteStatCard";

export default function VoteStatsGrid({ statistics }) {
  return (
    <section className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-4">
      <VoteStatCard
        icon={FaVoteYea}
        title="Consultations"
        value={statistics.total}
        hint={`${statistics.questions} question${
          statistics.questions > 1 ? "s" : ""
        } configurée${statistics.questions > 1 ? "s" : ""}`}
        variant="blue"
      />

      <VoteStatCard
        icon={FaUsers}
        title="En cours"
        value={statistics.active}
        hint="Votes actuellement ouverts aux utilisateurs"
        variant="emerald"
      />

      <VoteStatCard
        icon={FaClock}
        title="À venir"
        value={statistics.upcoming}
        hint="Consultations programmées prochainement"
        variant="amber"
      />

      <VoteStatCard
        icon={FaQuestionCircle}
        title="Participations"
        value={statistics.voters}
        hint="Cumul des votants sur toutes les consultations"
        variant="violet"
      />
    </section>
  );
}